// extracted by mini-css-extract-plugin
export default {"errorPage":"Page404_errorPage__g8edh"};